export const AI_ENDPOINTS = {
    // Agent endpoints
    AGENTS: "/agents",
    AGENT_CREATE: "/agents/create",
    AGENT_QUERIES: "/agents/queries",
    AGENT_QUERY_BY_ID: "/agents/query/:id",
    AGENT_DELETE: "/agents/delete/:id",
    AGENT_CHANGE_STATUS: "/agents/change-status",
    AGENT_UPDATE_PERSONA: "/agents/update-persona",
    AGENT_UPDATE_AI_CONFIG: "/agents/update-ai-configurations",
    AGENT_UPDATE_WIDGET: "/agents/update-widget",
    AGENT_QUERY: "/ai-agent/query",
    AGENT_QUERY_LMT: "/ai-agent/query-lmt",
    AGENT_QUERY_LMT_STREAM: "/ai-agent/query-lmt/stream",
    AGENT_QUERY_STREAM: "/ai-agent/query/stream",
    AGENT_WIDGET_COLOR_SUGGESTION: "/agents/widget-color-suggestion",
    AGENT_MODELS: "/agents/models",
    AGENT_RETRIEVAL_TEST: "/kb/retrieval-test/:id",
    AGENT_PUBLISH: "/agents/publish-agents/:id",

    // KB endpoints
    KB: "/kb",
    KB_KNOWLEDGES: "/kb/knowledges",
    KB_TEXT: "/kb/text",
    KB_LINK: "/kb/link",
    KB_QA: "/kb/qa",
    KB_FILE: "/kb/file",
    KB_UPDATE: "/kb/update",
    KB_DELETE: "/kb/delete/:id",
    KB_REEMBED: "/kb/reembed",
    KB_FOLDER_CREATE: "/kb/folder/create",
    KB_FOLDER_UPDATE: "/kb/folder/update",
    KB_FOLDER_LIST: "/kb/folders/list",
    KB_FOLDER_DELETE: "/kb/folder/delete",
    KB_FOLDER_AGENTS: "/kb/folder/agents",

    // Conversation endpoints
    CONVERSATION: "/conversation",
    CONVERSATION_SESSIONS: "/conversation/sessions",
    CONVERSATION_SESSION_BY_ID: "/conversation/sessions/:id",
    CONVERSATION_CONFIG: "/conversation/config",
    CONVERSATION_INITIATE: "/conversation/initiate",

    // Model endpoints
    MODELS: "/models",
    MODEL_BY_ID: "/models/:id",
    MODEL_VALIDATE: "/models/:id/validate",
    MODEL_SEED_PROVIDERS: "/models/seed/providers",
    MODEL_SEED_BY_PROVIDER: "/models/seed/providers/:provider",

    // Tool endpoints
    TOOLS: "/tools",
    TOOL_BY_ID: "/tools/:id",
    TOOL_MCP_SERVER: "/tools/mcp-server",
    TOOL_API: "/tools/api",
    TOOL_API_AUTH_CONFIG: "/tools/api-auth-config/:id",
    TOOL_API_ACTION: "/tools/api-action/:id",
    TOOL_SCHEMA: "/tools/schema",
    TOOL_SUMMARY: "/tools/:id/summary",
    TOOL_ASSOCIATED_AGENTS: "/tools/associated-agents/:id",
    TOOL_TEST_API_ACTION: "/tools/test-api-action",
    TOOL_DELETE_ACTION: "/tools/:id/action/:actionId",
    TOOL_TUTORIAL: "/tools/tutorial/:id",
    TOOL_MCP_SERVER_SETUP: "/tools/mcp-server-setup/:id",
    TOOL_REFRESH_MCP: "/tools/:id/refresh-mcp",
    TOOL_TEST_ACTION: "/tools/:id/test-action/:actionId",
    TOOL_SCHEMA_OPENAPI: "/tools/:id/schema/openapi",
    TOOL_TEST_MCP_AUTH: "/tools/:id/test-mcp-auth",
    TOOL_INITIATE_OAUTH: "/tools/:id/initiate-oauth",
    TOOL_COMPLETE_OAUTH: "/tools/:id/complete-oauth",
    TOOL_AGENT_COUNT: "/tools/:id/agent-count",

    // Chat endpoints
    CHAT_SESSION: "/chat/:id",
} as const;
